import * as errorPageTypes from '../../consts/app/errorPageTypes';
import * as httpErrorsTypes from '../../consts/app/httpErrorsTypes';
import {
    selectHolderUamAuthToken,
    selectUamApiKey,
    selectUamApiUrl,
    selectUamAuthToken,
} from '../../state/selectors/auth';
import {getState} from '../../state/store';
import arrayUtils from '../../utils/arrayUtils';
import urlUtils from '../../utils/urlUtils';
import authDataStoreService from '../auth/authDataStoreService';
import iccService from '../icc/iccService';
import appRouterService from '../route/appRouterService';
import YapClient from '../yap/yapClient';
import yapConnectionService from '../yap/yapConnectionService';

export default class UamClient extends YapClient {
    getHeaders = async (isHolder, refreshedAuthToken) => {
        const state = getState();
        let idToken = isHolder ? selectHolderUamAuthToken(state) : selectUamAuthToken(state);

        if (!refreshedAuthToken && !idToken) {
            const {AuthToken} = await iccService.fetchUamToken({isHolder});

            if (!AuthToken) return;

            idToken = AuthToken;
        }

        const headers = {
            Accept: 'application/json',
            id_token: refreshedAuthToken || idToken,
        };

        const xApiKey = selectUamApiKey(state);

        if (xApiKey) {
            headers['X-API-Key'] = xApiKey;
        }

        return headers;
    };

    errorCheck = async (
        error,
        methodUrl,
        onSuccess,
        ignoreErrorCodes = [],
        isNeedRedirectForOtherErrors = true,
        isHolderCall,
        codentify
    ) => {
        const status = error?.response?.status;

        ignoreErrorCodes = arrayUtils.toArray(ignoreErrorCodes);
        if (ignoreErrorCodes.includes(status)) return null;

        switch (status) {
            case httpErrorsTypes.NOT_AUTHORIZED: {
                if (!this.isTokenRefreshInProgress(isHolderCall) || codentify) {
                    this.setTokenRefreshInProgress(isHolderCall, true);

                    try {
                        authDataStoreService.clearUamApiToken(isHolderCall);

                        //during the e2e Tap Testing call we agreed not to integrate with UAM Refresh-Token
                        //await refreshUamToken();

                        const {AuthToken} = await iccService.fetchUamToken({
                            isRetry: false,
                            isHolder: isHolderCall,
                            codentify,
                        });

                        this.setTokenRefreshInProgress(isHolderCall, false);
                        return onSuccess ? onSuccess({refreshedAuthToken: AuthToken, isHolderCall}) : null;
                    } catch (e) {
                        this.setTokenRefreshInProgress(isHolderCall, false);
                    }
                }
                break;
            }
            case httpErrorsTypes.CONFLICT:
                await yapConnectionService.forceReconnectToCm(isHolderCall);
                return;
            default:
                if (isNeedRedirectForOtherErrors) {
                    appRouterService.forwardToErrorHandlingPage(errorPageTypes.UAM_TEMPORARY_ERROR);
                }
                return null;
        }
    };

    getRequestParams = async (headers, params, data, isHolder, refreshedAuthToken) => {
        const newHeaders = await this.getHeaders(isHolder, refreshedAuthToken);

        if (!newHeaders) return;

        if (refreshedAuthToken) {
            newHeaders.id_token = refreshedAuthToken;
        }

        headers = {...headers, ...newHeaders};
        return {headers, params, data};
    };

    getApiUrl = (methodName) => {
        const uamApiUrl = selectUamApiUrl(getState());

        return urlUtils.join(uamApiUrl, methodName);
    };
}
